export default "__VITE_ASSET__DCmTf5kv__"